import styled from 'styled-components';

export const CardRoot = styled.a`
  position: relative;
  display: block;
  border-radius: ${({ theme }) => theme.radiusSm};
  overflow: hidden;
  font-family: ${({ theme }) => theme.fontFamily};
  background: ${({ theme }) => theme.colors.card};
  border: 1px solid ${({ theme }) => theme.colors.border};
  box-shadow: ${({ theme }) => theme.shadowCard};
  border-left: 4px solid ${({ theme }) => theme.colors.crimson};
  padding: 1.5rem 1.5rem 1.6rem;
  text-decoration: none;
  color: inherit;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: ${({ theme }) => theme.shadowCardHover};
  }
`;

export const RowTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.85rem;
`;

export const AdTag = styled.span`
  padding: 0.2rem 0.55rem;
  border-radius: calc(${({ theme }) => theme.radiusSm} - 14px);
  background: rgba(220, 38, 38, 0.12);
  color: ${({ theme }) => theme.colors.crimson};
  font-size: ${({ theme }) => theme.fontClamp.xs};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

export const Sponsor = styled.span`
  font-size: ${({ theme }) => theme.fontClamp.sm};
  color: ${({ theme }) => theme.colors.mutedForeground};
`;

export const CardBgImage = styled.div`
  position: absolute;
  inset: 0;
  background-image: ${({ $src }) => ($src ? `url(${$src})` : 'none')};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 0;
`;

export const CardBgOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.45) 0%,
    rgba(0, 0, 0, 0.62) 45%,
    rgba(0, 0, 0, 0.75) 100%
  );
  z-index: 1;
`;

export const CardContent = styled.div`
  position: relative;
  z-index: 2;
`;

export const CardTitle = styled.h4`
  margin: 0;
  font-size: ${({ theme }) => theme.fontClamp.lg};
  font-weight: 700;
  line-height: 1.3;
  color: ${({ $hasImage, theme }) => ($hasImage ? '#ffffff' : theme.colors.foreground)};
`;

export const CardDesc = styled.p`
  margin: 0.65rem 0 0;
  font-size: ${({ theme }) => theme.fontClamp.sm};
  line-height: 1.55;
  color: ${({ $hasImage, theme }) => ($hasImage ? 'rgba(255, 255, 255, 0.88)' : theme.colors.mutedForeground)};
`;

export const CtaRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 1.1rem;
  padding: 0.65rem 1.15rem;
  border-radius: calc(${({ theme }) => theme.radiusSm} - 8px);
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primaryForeground};
  font-size: ${({ theme }) => theme.fontClamp.sm};
  font-weight: 700;
`;
